import { useMemo } from "react";
import BarChart from "src/components/ScoringChart/BarChart";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import useTokenHistogram from "src/hooks/useTokenHistogram";

export default function TokenHealthHistogram() {
  const tokenHistogram = useTokenHistogram(100);

  const { series, category, isLoading } = useMemo(() => {
    if (tokenHistogram) {
      let series = [];
      let category = [];
      const histogramArr = Object.entries(tokenHistogram);
      histogramArr.forEach((element, index) => {
        series.push(histogramArr[index][1]);
        category.push(`${histogramArr[index][0]}-${Number(element[0]) + 100}`);
      });
      return {
        isLoading: false,
        category: category,
        series: [
          {
            name: "Score ranges",
            data: series,
          },
        ],
      };
    }
    return {
      isLoading: true,
      series: [
        {
          name: "Score ranges",
          data: [],
        },
      ],
      category: [],
    };
  }, [tokenHistogram]);

  return (
    <PaperWrapper title="Token Health Histogram" paperProps={{ style: { height: 330 } }}>
      <BarChart
        isLoading={isLoading}
        categories={category}
        series={series}
        option={{
          chart: {
            height: 300,
          },
          yAxis: {
            gridLineWidth: 1,
          },
        }}
      />
    </PaperWrapper>
  );
}
